import { IS_PROGRESSIVE_SUPPORTED } from './browser/windowEnvironment';

// Voice, music and video are streamed through the service worker, which answers the page's /progressive and
// /download requests. A page that was force-reloaded (Ctrl+Shift+R) has no controlling worker until its next
// ordinary load, so those requests reach the host instead and never play. Until a worker controls the page, media
// is loaded whole, as upstream already does for a browser without service workers
export function isProgressiveAvailable() {
  return IS_PROGRESSIVE_SUPPORTED && Boolean(navigator.serviceWorker?.controller);
}

export function isBlobUrl(url?: string) {
  return Boolean(url?.startsWith('blob:'));
}
